"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var billing_method_1 = require("./billing_method");
var wrapped_location_1 = require("../lib/wrapped_location");
function PaywallBillingMethod() {
    return (React.createElement(billing_method_1.default, { onUpdateBillingMethodSuccess: wrapped_location_1.default.reload, returnURL: wrapped_location_1.default.href }));
}
exports.default = PaywallBillingMethod;
//# sourceMappingURL=paywall_billing_method.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/paywall_billing_method.js
// module id = IfJx
// module chunks = 20 21